import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";

const app = ReactDOM.createRoot(document.getElementById("app"));
app.render(
  //  <BrowserRouter basename={"/playground/help-centre/"}>
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
